var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "select-filter",
    class: [("select-filter_icon-" + (_vm.icon))],
    style: {
      width: _vm.width,
      fontSize: _vm.fontSize
    }
  }, [_vm.value && _vm.value.value ? _c('div', {
    staticClass: "select-filter__marker"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "select-filter__text"
  }, [_vm._v("\n    " + _vm._s(_vm.value && _vm.value.name || _vm.placeholder) + "\n  ")]), _vm._v(" "), _c('select', {
    staticClass: "select-filter__select",
    style: {
      fontSize: _vm.fontSize
    },
    on: {
      "change": _vm.onSelect
    }
  }, [_vm.value && _vm.value.value ? _c('option', [_vm._v("\n      Все\n    ")]) : _c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "selected": !(_vm.value && _vm.value.value)
    }
  }, [_vm._v("\n      Выберите значение\n    ")]), _vm._v(" "), _vm._l(_vm.list, function (el) {
    return _c('option', {
      key: el.value,
      domProps: {
        "value": el.value,
        "selected": el.value == (_vm.value && _vm.value.value)
      }
    }, [_vm._v("\n      " + _vm._s(el.name) + "\n    ")]);
  })], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }